/* @flow */
/* eslint-env es6,browser */

import { getCookie } from './cookie';
import { logDebug } from './logger';

/**
 * @module utils/ccpautils
 * @description CCPA Utility functions
 * @requires utils/cookie
 */

const USP_STRING_TTL: number = 30; // local USP String validity in seconds
const CCPA_OPTED_OUT_STRING: string = '1YYN'; // LoggedIn + CCPA Opt-out
const CCPA_DEFAULT_STRING: string = '1---'; // Not logged in (state unknown)
const CCPA_VERSION: number = 1;

/** US Privacy Cookie key */
const CCPA_COOKIE_KEY: string = 'usprivacy';

/** CCPA Commands */
const CCPA_CMD_GET_USP_DATA: string = 'getUSPData';
/** CCPA Commands End */

/** local cached CCPA USP String */
let uspString: string = CCPA_DEFAULT_STRING;
/** last updated time for uspString */
let lastUspStringUpdated: number = 0;

window.__uspapi =
  window.__uspapi ||
  function __uspapi(command: string, version: number, callback: uspCallback) {
    /* Version Check? */
    if (command === CCPA_CMD_GET_USP_DATA) {
      /* Get CCPA Cookie value */
      const ccpaCookie = getCookie(CCPA_COOKIE_KEY);
      /* Call callback with cookie value & CCPA version */
      callback(
        {
          version: CCPA_VERSION,
          uspString:
            ccpaCookie === null || ccpaCookie === ''
              ? CCPA_DEFAULT_STRING
              : ccpaCookie
        },
        true
      );
    }
  };

/**
 * Updates local uspString
 *
 * @param {boolean} [ignoreTTL=false] - Consider last update time ?
 *
 * @returns {undefined}
 */
export function updateUSPString(ignoreTTL: boolean = false) {
  // Get usp String and update local uspString value
  window.__uspapi(
    CCPA_CMD_GET_USP_DATA,
    CCPA_VERSION,
    (uspData: uspDataObject, success: boolean) => {
      const curTime = new Date().getTime() / 1000;
      if (
        success &&
        uspData.uspString &&
        (curTime - lastUspStringUpdated > USP_STRING_TTL ||
          ignoreTTL) /** if ignoreTTL is true update anyways, if callback is called with success value true and a valid ccpa usp string */
      ) {
        uspString = uspData.uspString;
        lastUspStringUpdated = curTime;
        logDebug(
          `uspString : ${uspString}, lastUspStringUpdated : ${lastUspStringUpdated}`
        );
      }
    }
  );
}

/**
 * Gets CCPA String
 *
 * @returns {string} - CCPA String
 */
export function getCCPA() {
  /**
   * Return locally cached CCPA USP string ( local cache is updated everytime as.get is called )
   */
  return uspString; // Call updateUSPString before returning, if lastUspStringUpdated value older than USP_STRING_TTL?
}

/**
 * Gets CCPA Opt-Out state
 *
 * @returns {boolean} - CCPA Out-Out state
 */
export function isCCPAOptedOut() {
  return getCCPA() === CCPA_OPTED_OUT_STRING; // True only if [ LoggedIn + CCPA Opt-out ]
}
